export const AVAILABLE_CITIES = ['Arboga', 'Frövi', 'Västerås'] as const;

export type AvailableCity = (typeof AVAILABLE_CITIES)[number];

export const CITY_OPTIONS = AVAILABLE_CITIES.map(city => ({
  label: city,
  value: city,
}));
